<template>
  <div id="app">
    <router-view v-loading="pageLoading" />
    <Confirm v-if="confirm.show" />
  </div>
</template>

<script>
export default {
  name: "App",
  mixins: [
    require("@mix/VuexCache").default
  ],
  computed: {
    ...mapState(["pageLoading", "confirm"]),
  },
  created() {
    window.WebInterface = {
      reloadUI: () => {//App從背景到前景喚醒時
        this.$store.commit("SET_ACTIVE_TIME", Date.now());
        this.checkVersion();
      },
      onMessage: () => {//App收到推播
        this.$store.commit("SET_MESSAGE_TIME", Date.now());
      },
      navigateToChannelRoom: (channelID) => {//App點擊推播進入頻道
        this.$router.push({ path: `/channel/room/${channelID}` });
      },
      returnUserInfo: (dataString) => {//App回傳使用者存於App內存資料
        if (dataString) {
          const { key = '', data = {} } = JSON.parse(dataString);

          if (key === "userInfo") {
            const { token, refreshToken, refreshTokenID } = data;
            this.$store.commit("SET_TOKEN", token || '');
            this.$store.commit("SET_REFRESH_TOKEN", refreshToken || '');
            this.$store.commit("SET_REFRESH_TOKEN_ID", refreshTokenID || '');
          }

          if (key === "tokenExpirationTime") {
            this.$store.commit("SET_TOKEN_EXPIRATION_TIME", data || null);
          }
        }
      }
    }
  },
  mounted() {
    this.checkVersion();
    //messageBox
    setTimeout(() => {
      this.$store.commit("SET_MESSAGE_BOX_READY", true);
    }, 1000);
  },
  methods: {
    checkVersion() {
      const RELOAD_LIMIT = 1000 * 60;
      const LAST_RELOAD_TIME = "LAST_RELOAD_TIME";
      const lastReloadTime = localStorage.getItem(LAST_RELOAD_TIME);
      const now = Date.now();
      if (lastReloadTime && now - Number(lastReloadTime) <= RELOAD_LIMIT) return;
      axios({
        url: "/version.txt",
        method: "get",
        params: { t: now }
      }).then(res => {
        if (BUILD_VERSION === res.data) return;
        localStorage.setItem(LAST_RELOAD_TIME, now.toString());
        location.href = QS.add(location.origin + location.pathname, { ...qs, t: Date.now() });
      }).catch(error => {
        console.error('版本檢查失敗:', error);
      })
    }
  }
};
</script>

<style></style>
